import { X, Focus } from 'lucide-react';

const segmentClass = (active) =>
	`px-3 py-1 text-sm rounded-full transition ${
		active ? 'bg-black text-white font-medium' : 'text-gray-500 hover:text-gray-800'
	}`;

const Divider = () => <span className='h-5 w-px bg-gray-200' aria-hidden='true' />;

/**
 * Filter bar rendered above data tables: an optional segmented control
 * (`segments` = [{ value, label }], one active at a time), removable chips
 * for each active filter (`pills` = [{ key, label }]), and a Filter button
 * that toggles the caller's own filter form. `children` render first (e.g.
 * a search box). This component doesn't own any filter state.
 */
export default function FilterPills({
	segments = [],
	activeSegment,
	onSegmentChange,
	pills = [],
	onRemove,
	onOpenPicker,
	children,
	className = '',
}) {
	return (
		<div className={`flex flex-wrap items-center gap-3 mb-5 ${className}`}>
			{children}

			{segments.length > 0 && (
				<div className='inline-flex items-center rounded-full bg-gray-100 p-1.5'>
					{segments.map((segment) => (
						<button
							key={segment.value}
							type='button'
							onClick={() => onSegmentChange(segment.value)}
							className={segmentClass(activeSegment === segment.value)}
						>
							{segment.label}
						</button>
					))}
				</div>
			)}

			{pills.length > 0 && (
				<>
					{segments.length > 0 && <Divider />}
					{pills.map((pill) => (
						<span
							key={pill.key}
							className='inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-3 py-1.5 text-sm font-medium text-gray-800'
						>
							{pill.label}
							<button
								type='button'
								onClick={() => onRemove(pill.key)}
								className='text-gray-400 hover:text-gray-700'
								aria-label={`Remove ${pill.label} filter`}
							>
								<X className='h-3.5 w-3.5' />
							</button>
						</span>
					))}
				</>
			)}

			{onOpenPicker && (
				<button
					type='button'
					onClick={onOpenPicker}
					className='inline-flex items-center gap-1.5 rounded-full border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50'
				>
					<Focus className='h-3.5 w-3.5' />
					Filter
				</button>
			)}
		</div>
	);
}
